class HeaderDropdownReveal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.externalEls.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'mouseenter', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.externalEls?.trigger?.selector)

    if (!triggerEl) return

    this.externalEls.trigger.elements.forEach(trigger => {
      trigger.setAttribute('aria-pressed', trigger === triggerEl)
    })

    this.els.panel.elements.forEach(panelEl => {
      const currentState =
        triggerEl.dataset.handle === panelEl.dataset.parentHandle
      panelEl.setAttribute('aria-hidden', !currentState)
    })
  }
}

if (!customElements.get('header-dropdown-reveal')) {
  customElements.define('header-dropdown-reveal', HeaderDropdownReveal)
}
